function getUrlPrefix(teamId: string) {
  return `/stores/${teamId}`;
}

const SUPPORT_TICKET_ROUTE_ID_PATTERN = /^cnv_[0-9A-Za-z]+$/;

export function isSupportTicketRouteId(id: string): boolean {
  return SUPPORT_TICKET_ROUTE_ID_PATTERN.test(id);
}

export function getBaseSettingsLink(teamId: string) {
  return `${getUrlPrefix(teamId)}/settings`;
}

export enum BillingTab {
  GENERAL = "general",
  RETURNS_AGENT_BILLING = "returns-agent-billing",
  RETURNS = "returns",
  SUPPORT = "support",
  ORDER_TRACKING = "order-tracking",
  MARKETING_EMAIL_SMS = "marketing-email-sms",
  OUTBOUND_LABELS = "outbound",
  CHECKOUT_OPTIMIZATION = "checkout-optimization",
  RECOMMERCE = "recommerce",
  AEO = "aeo",
  IMS = "ims",
  SUPPLIES = "supplies",
  INVOICES = "invoices",
  BILLS = "bills",
  REPORTS = "reports",
}
export const CURRENT_BILLING_TAB_QUERY = "currentTab";

export function getBillingPageLink(teamId: string, tab: BillingTab): string {
  return `${getBaseSettingsLink(teamId)}/billing/${tab}`;
}

export enum TryFirstTab {
  GENERAL = "general",
  DISPLAY = "display",
  INFO_MODAL = "info-modal",
}
export const CURRENT_TRY_FIRST_TAB_QUERY = "currentTab";

export function getTryFirstPageLink(teamId: string, tab: BillingTab): string {
  return `${getBaseSettingsLink(teamId)}/billing?${CURRENT_BILLING_TAB_QUERY}=${tab}`;
}

export enum CartOptimizationTab {
  SHIPPING_REWARDS = "shipping-rewards",
  CART_TOTALS = "cart-totals",
}
export const CURRENT_CART_OPTIMIZATION_TAB_QUERY = "currentTab";

export function getCustomerSatisfactionPageLink(teamId: string): string {
  return `${getBaseSettingsLink(teamId)}/customer-satisfaction`;
}

export function getBaseSupportLink(teamId: string) {
  return `${getUrlPrefix(teamId)}/support/table/all`;
}

export function getSingleConversationLink(
  teamId: string,
  conversationId: string,
) {
  return `${getBaseSupportLink(teamId)}?activeConversationId=${conversationId}`;
}

/**
 * Support-v2 ticket detail route. v2 CSAT rows reference a SupportTicketId
 * (`cnv_…`) rather than a Mongo conversation ObjectId.
 */
export function getSingleSupportTicketLink(
  teamId: string,
  supportTicketId: string,
) {
  return `${getUrlPrefix(teamId)}/support-v2/${supportTicketId}`;
}

export function getSupportV2ListLink(teamId: string, fg?: string) {
  const base = `${getUrlPrefix(teamId)}/support-v2`;
  return fg ? `${base}?${new URLSearchParams({ fg }).toString()}` : base;
}

export const NEW_SUPPORT_TICKET_QUERY = "newTicket";

/**
 * Support-v2 inbox link that opens the new-ticket modal on arrival. Seed the
 * customer via storeNewTicketCustomerSeed, not URL params (PII in URLs).
 */
export function getNewSupportTicketLink(teamId: string) {
  return `${getUrlPrefix(teamId)}/support-v2?${NEW_SUPPORT_TICKET_QUERY}=true`;
}
